import { render, staticRenderFns } from "./node-window.vue?vue&type=template&id=1008ac28&scoped=true&"
import script from "./node-window.vue?vue&type=script&lang=ts&"
export * from "./node-window.vue?vue&type=script&lang=ts&"
import style0 from "./node-window.vue?vue&type=style&index=0&id=1008ac28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008ac28",
  null
  
)

export default component.exports